export const config = {
    env: "local",
    // backend_url: "https://cms.umms.med.umich.edu/data/api-flask",
    // backend_url: "http://localhost:3001",
    web_prefix: "/data_gov",
    api_url: "https://galaxy.eecs.umich.edu/data_gov_api/api",
    ds_per_page: 15

};

